import { Box } from "@mui/material";
import { useStore } from "@priolo/jon";
import PlaceholderCmp, { ICON_TYPE } from "components/controls/PlaceholderCmp";
import TasksList from "pages/farms/tasks/list/TasksList";
import { FunctionComponent, useMemo } from "react";
import dialogSo from "stores/cycle/editDialog";
import querySo from "stores/route/query";
import { URL_PAR } from 'stores/route/utils/types';
import taskSo from "stores/task";
import taskDetailSo from "stores/task/taskDetail";
import { getTaskFiltered, groupTasksByDate } from "stores/task/utils";
import { Task } from "types/Task";



const TasksTab: FunctionComponent = () => {

	// STORE
	useStore(dialogSo)
	const taskSa = useStore(taskSo)
	const querySa = useStore(querySo)
	
	// HOOKs

	// HANDLERs
	const handleTaskSelect = (task: Task) => taskDetailSo.open({ task })

	// RENDER
	const groups = useMemo(() => {
		const [cycleSel] = querySo.getSearchUrl([URL_PAR.CYCLE_SEL])
		return groupTasksByDate(getTaskFiltered(taskSo.state.all, null, null, null, cycleSel))
	}, [taskSa.all, querySa.queryUrl])

	if ( groups.length == 0 ) {
		return <PlaceholderCmp
			title="THERE ARE NO TASKS" 
			subtitle="this cycle has no tasks" 
			iconType={ICON_TYPE.VOID}
		/>
	}

	return (
		<Box sx={{ display: "flex", flexDirection: "column"}}>
			<TasksList
				onClickTask={handleTaskSelect}
				groups={groups}
			/>
		</Box>
	)
}

export default TasksTab

